import { z } from 'zod';
import type { RespondedType } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const logMessageSchema = z.object({
  UserAgent: z.string(),
  Log: z.string(),
});

const LogActionScheme = z.enum([
  'DELETE_MESSAGE', //本地刪除訊息
  'DELETE_SESSION', // 本地刪除聊天室
  'CLEAR_CACHE', // 清除緩存
  'MARK_UNREAD', // 聊天室標記成未讀
]);

export type LogAction = z.infer<typeof LogActionScheme>;
export const logMessage = (action: LogAction, message?: string | Record<string, unknown>) => {
  fetcher<RespondedType>('/LogMessage', {
    UserAgent: navigator.userAgent,
    Log: JSON.stringify({ action, message }),
  });
};
